// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	font-family: "Fira Sans", sans-serif;
	font-weight: 300;
}

/* Pagina inicial */
.content-box {
	max-width: 1000px;
	margin: auto;
}
/*
.info-box{
	max-width: 1200px;
    margin: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr); 
}
*/
.info-box{
    margin: auto;
    display: inline-block;
    width: 100%;
	text-align: center;
    margin-bottom: 10px;
}
.box-logo {
	max-width: 300px;
	margin: auto;
}

.box-txto {
	border-top: 2px solid #e13034;
	margin: 10px auto;
	color: #4C4D5A;
}

.txto-ppal {
	font-weight: 300;
}

.bold-txt {
	font-weight: bold;
}

.search-box {
	display: flex;
	justify-content: center;
	background: #f7f7f7;
	width: 100%;
	padding: 50px 20px;
}

.search-input {
	width: 76%;
	padding: 10px 0;
	border: 1px solid #d6d6d6;
	border-radius: 5px;
}

::placeholder {
	color: #969696;
	opacity: 1;
	/* Firefox */
	padding: 5px 15px;
	font-family: "Fira Sans", sans-serif;
	font-size: 15px;
	font-weight: bolder;
}

::-ms-input-placeholder {
	/* Edge 12-18 */
	color: #969696;
	padding: 5px;
	font-family: "Fira Sans", sans-serif;
	font-size: 15px;
	font-weight: bolder;
}

.search-btn {
	background: #dc0f1a;
	color: #fff;
	border: none;
	padding: 10px 30px;
	text-transform: uppercase;
	font-weight: bold;
	width: 20%;
	margin: 0 15px;
	border-radius: 5px;
	cursor: pointer;
}
#root > section > div > div.search-box > div{
    position: relative;
    box-sizing: border-box;
    width: 100%;
}
.info-extra-number{
	position: absolute;
	right: 20px;
	bottom: 5px;
}
sup {
	font-style: italic;
}

@media(max-width: 700px) {
	.content-box {
		padding: 20px;
	}

	.search-box {
		/*flex-direction: column;*/
		width: auto;
		padding: 20px;
	}

	.search-input {
		width: 100%;
		margin: 10px auto;
	}
/*
	.search-btn {
		width: 100%;
		display: block;
		margin: auto;
	}*/
	.info-extra-number {
		position: absolute;
		right: -25px;
		bottom: 18px;
	}
}

/* Fin Pagina inicial */

/* Pagina interior */
.border-btm {
	padding: 15px 0;
	border-bottom: 1px solid #dc0f1a;
}

.box-logo-interior {
	width: 200px;
	display: inline-block;
}

.search-box-interior {
	width: 60%;
	display: flex;
	justify-content: flex-end;
	float: right;
}

.search-input-interior {
	width: 67%;
	padding: 10px 0;
	border: 1px solid #d6d6d6;
	border-radius: 5px;
}

.search-btn-interior {
	background: #dc0f1a;
	color: #fff;
	border: none;
	padding: 10px 20px;
	text-transform: uppercase;
	font-weight: bold;
	width: 23%;
	border-radius: 5px;
	margin: 0;
}

.info-comuna {
	font-family:"Bebas Neue", sans-serif;
	width: 40%;
	margin: 20px 0;
	display: inline-block;
	min-height: 120px;
}

.box-glosario {
	width: 40%;
	font-family:"Bebas Neue", sans-serif;
	margin: 20px 0;
	display: inline-block;
	text-align: right;
    float: right;
}

.title-glosario {
    text-align: right;
    display: inline-block;
    vertical-align: inherit;
    color: #476dd6;
    font-size: 30px;
    margin-left: 7px;
	text-decoration: none;
}

.subtitle-comuna-box {
	margin: 0;
	background: #4c4d5a;
	color: #fff;
	text-transform: uppercase;
	font-weight: 400;
	letter-spacing: 1px;
	padding: 2px 10px;
	display: table;

}

.comuna-elegida {
    color: #4d75da;
    margin: 0;
    text-transform: uppercase;
    display: inline; 
    margin-right: 10px;
    font-size: 40px;
}

.icon-box-title {
	width: 25px;
	display: inline-block;
	height: 25px;
	vertical-align: initial;
}

.icon-arrow img {
	width: 100%;
}

/*submenu*/
.scrollmenu {
	font-family:"Bebas Neue", sans-serif;
	overflow: auto;
	white-space: nowrap;
	text-transform: uppercase;
	font-weight: 700;
}

.link-tema {
    display: inline-block;
    color: #3d4552;
    text-align: center;
    padding: 10px 20px;
    text-decoration: none;
    font-size: 26px;
    min-width: 115px;
    letter-spacing: 1px;
}

.link-tema:hover {
	background-color: #86a6f5;
	color: #fff;
}

.select-link {
	background: #4d75da;
	color: #fff;
}

.title-box {
	margin: 20px 0 20px 20px;
}

.title-comuna {
	color: #4d75da;
	text-transform: uppercase;
	font-size: 30px;
	margin: 0;
}

.subtitle-region {
	color: #3d4552;
	margin: 0;
}

.icon-box {
	width: 20%;
	display: inline-table;
	vertical-align: middle;
	text-align: center;
	color: #3d4552;
}

.icon {
	width: 60px;
	height: 60px;
	padding: 20px;
}

.title-info {
	font-size: 30px;
	margin: 0;
}

.subtitle-info {
	font-weight: 500;
	font-size: 20px;
}

.fuente-box {
	text-align: center;
}
.fuente-txt{
    font-size: 12px;
}
.title-fuente {
	color: #3d4552;
}

/*GRAFICOS*/

/*.grafico-box-principal */
.info-variable{
	width: 45%;
	margin: 20px auto;
	display: inline-block;
	vertical-align: top;
	padding: 0 20px;
	text-align: center;
}
table,th, tr, td{
    text-align: left;
    border: 1px solid #555555;
    padding: 8px;
	color: #555555;
}
th{
	background: #4d75da ;
	color: #fff;
}
table {
	border-collapse: collapse;
  }
 table > tbody > tr > td:nth-child(2) {
	text-align: center;
 }
.grafico-box {
	width: 45%;
	display: inline-block;
	vertical-align: top;
}

.title-info-variable {
	text-align: center;
	color: #3d4552;
}

.img-grafico {
	width: 100%;
}

.chart-text{
	font-size: 1em;
}

/* Select */
/*
.css-b62m3t-container {
	width: 60% !important;
}*/
.habit-icon{
	vertical-align: middle;
}
.mg-tp-60{
	margin-top: 60px;
}
.box-datatvn{
    width: 200px;
    display: block;
    margin: 20px auto;
}

.mg-tp-70{
	margin-top: 70px;
}

.text-start{
	text-align: start !important;
}

@media(max-width: 799px){
	.content-box {
	    padding: 10px;
	}
	.info-comuna,
	.box-glosario,
	.search-box-interior,
	.grafico-box-principal,
	.grafico-box{
    width: 100%;
    float: none;
    display: block;
    margin: auto;
	}
		.box-logo-interior {
	    width: 70%;
	    margin: auto;
	    display: block;
	}
	.search-input-interior,
	#root > section > div > div.search-box > div,
	#root > div > section:nth-child(1) > div > div.search-box-interior > div {
	    width: 65%;
	    /* padding: 10px 0;
	   border: 1px solid #d6d6d6;*/
	    border-radius: 5px;
	    margin-right: 2%;
		display: inline-block;
	}
	.search-btn {
	    background: #dc0f1a;
	    color: #fff;
	    border: none;
	    padding: 10px 20px;
	    text-transform: uppercase;
	    font-weight: bold;
	    width: 30%;
	    border-radius: 5px;
	    margin: 0;
	    display: inline-block;
	}
	.border-btm{
		padding: 0px 0;
	}
	.info-comuna{
		width: 60%;
		display: inline-block;
		min-height: 60px;
	}
	.box-glosario{
		width: 35%;
		display: inline-block;
		/*vertical-align: super;*/
	}
	.title-glosario{
		font-size: 20px;
	}
	.link-tema{
		padding: 10px 7px;
		font-size: 17px;
		min-width: 40px;
		letter-spacing: 1px;
	}
	.subtitle-comuna-box{
		font-size: 20px;
	}
	.comuna-elegida{
		font-size: 25px;
		letter-spacing: 1px;
	}
	.icon-box {
		width: 100%;
		margin: 15px auto;
	}
  	.icon {
		width: 100px;
		height: 60px;
		padding: 10px;
	}
	.info-box{
		display: block;
	}
	.puntos-limpios-container{
		display: block !important;
	}
	.info-variable {
		width: 90%;
		margin: 5px auto;
		display: inline-block;
		vertical-align: top;
		padding: 0 15px;
		text-align: center;
	}
	.box-glosario > div:nth-child(2) > a{
		max-width: 75px;
		text-align: left;
		margin-left: 4px;
	}
	.icon-box-title {
		vertical-align: top;
	}
	.mg-tp-10 {
		margin-top:10px;
	}
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAGA;CACC,oCAAoC;CACpC,gBAAgB;AACjB;;AAEA,mBAAmB;AACnB;CACC,iBAAiB;CACjB,YAAY;AACb;AACA;;;;;;;CAOC;AACD;IACI,YAAY;IACZ,qBAAqB;IACrB,WAAW;CACd,kBAAkB;IACf,mBAAmB;AACvB;AACA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,6BAA6B;CAC7B,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,eAAe;CACf,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,UAAU;CACV,YAAY;CACZ,iBAAiB;CACjB,oCAAoC;CACpC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,YAAY;CACZ,oCAAoC;CACpC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,iBAAiB;CACjB,UAAU;CACV,cAAc;CACd,kBAAkB;CAClB,eAAe;AAChB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,0BAA0B;EAC1B,WAAW;EACX,aAAa;CACd;;CAEA;EACC,WAAW;EACX,iBAAiB;CAClB;AACD;;;;;GAKG;CACF;EACC,kBAAkB;EAClB,YAAY;EACZ,YAAY;CACb;AACD;;AAEA,uBAAuB;;AAEvB,oBAAoB;AACpB;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,UAAU;CACV,aAAa;CACb,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,UAAU;CACV,eAAe;CACf,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,iBAAiB;CACjB,UAAU;CACV,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,oCAAoC;CACpC,UAAU;CACV,cAAc;CACd,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,oCAAoC;CACpC,cAAc;CACd,qBAAqB;CACrB,iBAAiB;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;CACnB,qBAAqB;AACtB;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,WAAW;CACX,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;CACjB,cAAc;;AAEf;;AAEA;IACI,cAAc;IACd,SAAS;IACT,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,WAAW;AACZ;;AAEA,UAAU;AACV;CACC,oCAAoC;CACpC,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,eAAe;CACf,SAAS;AACV;;AAEA;CACC,cAAc;CACd,SAAS;AACV;;AAEA;CACC,UAAU;CACV,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,eAAe;CACf,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;AACA;IACI,eAAe;AACnB;AACA;CACC,cAAc;AACf;;AAEA,WAAW;;AAEX,0BAA0B;AAC1B;CACC,UAAU;CACV,iBAAiB;CACjB,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;CACf,cAAc;AACf;AACA;CACC,oBAAoB;CACpB,WAAW;AACZ;AACA;CACC,yBAAyB;EACxB;CACD;CACA,kBAAkB;CAClB;AACD;CACC,UAAU;CACV,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA,WAAW;AACX;;;EAGE;AACF;CACC,sBAAsB;AACvB;AACA;CACC,gBAAgB;AACjB;AACA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC;KACI,aAAa;CACjB;CACA;;;;;IAKG,WAAW;IACX,WAAW;IACX,cAAc;IACd,YAAY;CACf;EACC;KACG,UAAU;KACV,YAAY;KACZ,cAAc;CAClB;CACA;;;KAGI,UAAU;KACV;+BAC0B;KAC1B,kBAAkB;KAClB,gBAAgB;EACnB,qBAAqB;CACtB;CACA;KACI,mBAAmB;KACnB,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,yBAAyB;KACzB,iBAAiB;KACjB,UAAU;KACV,kBAAkB;KAClB,SAAS;KACT,qBAAqB;CACzB;CACA;EACC,cAAc;CACf;CACA;EACC,UAAU;EACV,qBAAqB;EACrB,gBAAgB;CACjB;CACA;EACC,UAAU;EACV,qBAAqB;EACrB,yBAAyB;CAC1B;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,WAAW;EACX,iBAAiB;CAClB;GACE;EACD,YAAY;EACZ,YAAY;EACZ,aAAa;CACd;CACA;EACC,cAAc;CACf;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;CACnB;CACA;EACC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;AACD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');\n\nbody {\n\tfont-family: \"Fira Sans\", sans-serif;\n\tfont-weight: 300;\n}\n\n/* Pagina inicial */\n.content-box {\n\tmax-width: 1000px;\n\tmargin: auto;\n}\n/*\n.info-box{\n\tmax-width: 1200px;\n    margin: auto;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); \n}\n*/\n.info-box{\n    margin: auto;\n    display: inline-block;\n    width: 100%;\n\ttext-align: center;\n    margin-bottom: 10px;\n}\n.box-logo {\n\tmax-width: 300px;\n\tmargin: auto;\n}\n\n.box-txto {\n\tborder-top: 2px solid #e13034;\n\tmargin: 10px auto;\n\tcolor: #4C4D5A;\n}\n\n.txto-ppal {\n\tfont-weight: 300;\n}\n\n.bold-txt {\n\tfont-weight: bold;\n}\n\n.search-box {\n\tdisplay: flex;\n\tjustify-content: center;\n\tbackground: #f7f7f7;\n\twidth: 100%;\n\tpadding: 50px 20px;\n}\n\n.search-input {\n\twidth: 76%;\n\tpadding: 10px 0;\n\tborder: 1px solid #d6d6d6;\n\tborder-radius: 5px;\n}\n\n::placeholder {\n\tcolor: #969696;\n\topacity: 1;\n\t/* Firefox */\n\tpadding: 5px 15px;\n\tfont-family: \"Fira Sans\", sans-serif;\n\tfont-size: 15px;\n\tfont-weight: bolder;\n}\n\n::-ms-input-placeholder {\n\t/* Edge 12-18 */\n\tcolor: #969696;\n\tpadding: 5px;\n\tfont-family: \"Fira Sans\", sans-serif;\n\tfont-size: 15px;\n\tfont-weight: bolder;\n}\n\n.search-btn {\n\tbackground: #dc0f1a;\n\tcolor: #fff;\n\tborder: none;\n\tpadding: 10px 30px;\n\ttext-transform: uppercase;\n\tfont-weight: bold;\n\twidth: 20%;\n\tmargin: 0 15px;\n\tborder-radius: 5px;\n\tcursor: pointer;\n}\n#root > section > div > div.search-box > div{\n    position: relative;\n    box-sizing: border-box;\n    width: 100%;\n}\n.info-extra-number{\n\tposition: absolute;\n\tright: 20px;\n\tbottom: 5px;\n}\nsup {\n\tfont-style: italic;\n}\n\n@media(max-width: 700px) {\n\t.content-box {\n\t\tpadding: 20px;\n\t}\n\n\t.search-box {\n\t\t/*flex-direction: column;*/\n\t\twidth: auto;\n\t\tpadding: 20px;\n\t}\n\n\t.search-input {\n\t\twidth: 100%;\n\t\tmargin: 10px auto;\n\t}\n/*\n\t.search-btn {\n\t\twidth: 100%;\n\t\tdisplay: block;\n\t\tmargin: auto;\n\t}*/\n\t.info-extra-number {\n\t\tposition: absolute;\n\t\tright: -25px;\n\t\tbottom: 18px;\n\t}\n}\n\n/* Fin Pagina inicial */\n\n/* Pagina interior */\n.border-btm {\n\tpadding: 15px 0;\n\tborder-bottom: 1px solid #dc0f1a;\n}\n\n.box-logo-interior {\n\twidth: 200px;\n\tdisplay: inline-block;\n}\n\n.search-box-interior {\n\twidth: 60%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tfloat: right;\n}\n\n.search-input-interior {\n\twidth: 67%;\n\tpadding: 10px 0;\n\tborder: 1px solid #d6d6d6;\n\tborder-radius: 5px;\n}\n\n.search-btn-interior {\n\tbackground: #dc0f1a;\n\tcolor: #fff;\n\tborder: none;\n\tpadding: 10px 20px;\n\ttext-transform: uppercase;\n\tfont-weight: bold;\n\twidth: 23%;\n\tborder-radius: 5px;\n\tmargin: 0;\n}\n\n.info-comuna {\n\tfont-family:\"Bebas Neue\", sans-serif;\n\twidth: 40%;\n\tmargin: 20px 0;\n\tdisplay: inline-block;\n\tmin-height: 120px;\n}\n\n.box-glosario {\n\twidth: 40%;\n\tfont-family:\"Bebas Neue\", sans-serif;\n\tmargin: 20px 0;\n\tdisplay: inline-block;\n\ttext-align: right;\n    float: right;\n}\n\n.title-glosario {\n    text-align: right;\n    display: inline-block;\n    vertical-align: inherit;\n    color: #476dd6;\n    font-size: 30px;\n    margin-left: 7px;\n\ttext-decoration: none;\n}\n\n.subtitle-comuna-box {\n\tmargin: 0;\n\tbackground: #4c4d5a;\n\tcolor: #fff;\n\ttext-transform: uppercase;\n\tfont-weight: 400;\n\tletter-spacing: 1px;\n\tpadding: 2px 10px;\n\tdisplay: table;\n\n}\n\n.comuna-elegida {\n    color: #4d75da;\n    margin: 0;\n    text-transform: uppercase;\n    display: inline; \n    margin-right: 10px;\n    font-size: 40px;\n}\n\n.icon-box-title {\n\twidth: 25px;\n\tdisplay: inline-block;\n\theight: 25px;\n\tvertical-align: initial;\n}\n\n.icon-arrow img {\n\twidth: 100%;\n}\n\n/*submenu*/\n.scrollmenu {\n\tfont-family:\"Bebas Neue\", sans-serif;\n\toverflow: auto;\n\twhite-space: nowrap;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n}\n\n.link-tema {\n    display: inline-block;\n    color: #3d4552;\n    text-align: center;\n    padding: 10px 20px;\n    text-decoration: none;\n    font-size: 26px;\n    min-width: 115px;\n    letter-spacing: 1px;\n}\n\n.link-tema:hover {\n\tbackground-color: #86a6f5;\n\tcolor: #fff;\n}\n\n.select-link {\n\tbackground: #4d75da;\n\tcolor: #fff;\n}\n\n.title-box {\n\tmargin: 20px 0 20px 20px;\n}\n\n.title-comuna {\n\tcolor: #4d75da;\n\ttext-transform: uppercase;\n\tfont-size: 30px;\n\tmargin: 0;\n}\n\n.subtitle-region {\n\tcolor: #3d4552;\n\tmargin: 0;\n}\n\n.icon-box {\n\twidth: 20%;\n\tdisplay: inline-table;\n\tvertical-align: middle;\n\ttext-align: center;\n\tcolor: #3d4552;\n}\n\n.icon {\n\twidth: 60px;\n\theight: 60px;\n\tpadding: 20px;\n}\n\n.title-info {\n\tfont-size: 30px;\n\tmargin: 0;\n}\n\n.subtitle-info {\n\tfont-weight: 500;\n\tfont-size: 20px;\n}\n\n.fuente-box {\n\ttext-align: center;\n}\n.fuente-txt{\n    font-size: 12px;\n}\n.title-fuente {\n\tcolor: #3d4552;\n}\n\n/*GRAFICOS*/\n\n/*.grafico-box-principal */\n.info-variable{\n\twidth: 45%;\n\tmargin: 20px auto;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tpadding: 0 20px;\n\ttext-align: center;\n}\ntable,th, tr, td{\n    text-align: left;\n    border: 1px solid #555555;\n    padding: 8px;\n\tcolor: #555555;\n}\nth{\n\tbackground: #4d75da ;\n\tcolor: #fff;\n}\ntable {\n\tborder-collapse: collapse;\n  }\n table > tbody > tr > td:nth-child(2) {\n\ttext-align: center;\n }\n.grafico-box {\n\twidth: 45%;\n\tdisplay: inline-block;\n\tvertical-align: top;\n}\n\n.title-info-variable {\n\ttext-align: center;\n\tcolor: #3d4552;\n}\n\n.img-grafico {\n\twidth: 100%;\n}\n\n.chart-text{\n\tfont-size: 1em;\n}\n\n/* Select */\n/*\n.css-b62m3t-container {\n\twidth: 60% !important;\n}*/\n.habit-icon{\n\tvertical-align: middle;\n}\n.mg-tp-60{\n\tmargin-top: 60px;\n}\n.box-datatvn{\n    width: 200px;\n    display: block;\n    margin: 20px auto;\n}\n\n.mg-tp-70{\n\tmargin-top: 70px;\n}\n\n.text-start{\n\ttext-align: start !important;\n}\n\n@media(max-width: 799px){\n\t.content-box {\n\t    padding: 10px;\n\t}\n\t.info-comuna,\n\t.box-glosario,\n\t.search-box-interior,\n\t.grafico-box-principal,\n\t.grafico-box{\n    width: 100%;\n    float: none;\n    display: block;\n    margin: auto;\n\t}\n\t\t.box-logo-interior {\n\t    width: 70%;\n\t    margin: auto;\n\t    display: block;\n\t}\n\t.search-input-interior,\n\t#root > section > div > div.search-box > div,\n\t#root > div > section:nth-child(1) > div > div.search-box-interior > div {\n\t    width: 65%;\n\t    /* padding: 10px 0;\n\t   border: 1px solid #d6d6d6;*/\n\t    border-radius: 5px;\n\t    margin-right: 2%;\n\t\tdisplay: inline-block;\n\t}\n\t.search-btn {\n\t    background: #dc0f1a;\n\t    color: #fff;\n\t    border: none;\n\t    padding: 10px 20px;\n\t    text-transform: uppercase;\n\t    font-weight: bold;\n\t    width: 30%;\n\t    border-radius: 5px;\n\t    margin: 0;\n\t    display: inline-block;\n\t}\n\t.border-btm{\n\t\tpadding: 0px 0;\n\t}\n\t.info-comuna{\n\t\twidth: 60%;\n\t\tdisplay: inline-block;\n\t\tmin-height: 60px;\n\t}\n\t.box-glosario{\n\t\twidth: 35%;\n\t\tdisplay: inline-block;\n\t\t/*vertical-align: super;*/\n\t}\n\t.title-glosario{\n\t\tfont-size: 20px;\n\t}\n\t.link-tema{\n\t\tpadding: 10px 7px;\n\t\tfont-size: 17px;\n\t\tmin-width: 40px;\n\t\tletter-spacing: 1px;\n\t}\n\t.subtitle-comuna-box{\n\t\tfont-size: 20px;\n\t}\n\t.comuna-elegida{\n\t\tfont-size: 25px;\n\t\tletter-spacing: 1px;\n\t}\n\t.icon-box {\n\t\twidth: 100%;\n\t\tmargin: 15px auto;\n\t}\n  \t.icon {\n\t\twidth: 100px;\n\t\theight: 60px;\n\t\tpadding: 10px;\n\t}\n\t.info-box{\n\t\tdisplay: block;\n\t}\n\t.puntos-limpios-container{\n\t\tdisplay: block !important;\n\t}\n\t.info-variable {\n\t\twidth: 90%;\n\t\tmargin: 5px auto;\n\t\tdisplay: inline-block;\n\t\tvertical-align: top;\n\t\tpadding: 0 15px;\n\t\ttext-align: center;\n\t}\n\t.box-glosario > div:nth-child(2) > a{\n\t\tmax-width: 75px;\n\t\ttext-align: left;\n\t\tmargin-left: 4px;\n\t}\n\t.icon-box-title {\n\t\tvertical-align: top;\n\t}\n\t.mg-tp-10 {\n\t\tmargin-top:10px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
